
export default function HeadNav() {
    console.log("HeadNav mounted");

  return (
  <></>
  );
}
